import { faDigits } from "../i18n/digits";
import { fa } from "../i18n/fa";
import { botOrdinal } from "./opponent-number";

/**
 * THE NAME OF A شلم SEAT WITH NO KNOWN PLAYER — the `fallback` half of `resolveSeatName`, for the
 * felt (`ShelemTable`) AND the end-of-match card (`WinOverlay`, P1 Task 7: «two team rows and REAL
 * names»). In its own module for بی‌دل's reason (`hearts-seat-label.ts`): the felt and the card must
 * call the same chair by the same name, and the container importing the screen module to share it
 * would couple them (every test that mocks `ShelemTable` would lose it). Moved here byte for byte.
 */

/** The partner opposite you, when no known player sits there: «بات ۳» — your team's colour says it is
 *  your partner. Exported (the value, whatever it is) for the seat tests. */
export const PARTNER_NAME = `${fa.shelem.bot} ${faDigits(3)}`;

/** The name shown for an ABSOLUTE seat with no known player: «شما» for you, {@link PARTNER_NAME}
 *  opposite you, and the two opponents numbered by ABSOLUTE seat (ISSUE B — numbered relative to
 *  you, two teammates called the same opponent bot different numbers). */
export function shelemSeatFallback(seat: number, you: number, seats: number): string {
  if (seat === you) return fa.shelem.you;
  if (seat === (you + 2) % seats) return PARTNER_NAME;
  const oppA = (you + 1) % seats;
  const oppB = (you + 3) % seats;
  const isOpponent = (x: number): boolean => x === oppA || x === oppB;
  return `${fa.shelem.bot} ${faDigits(botOrdinal(seat, seats, isOpponent))}`;
}
